import { useLogout } from "@repo/ui";
import { type FC } from "react";
import { TriggerButton } from "../Link";

const LogoutButton: FC = () => {
	const { click, isDisabled } = useLogout();

	return (
		<TriggerButton onClick={click} disabled={isDisabled}>
			Odhlásit se
		</TriggerButton>
	);
}

export default LogoutButton;
